import { render, staticRenderFns } from "./FormulateAutosuggest.vue?vue&type=template&id=6822e9e4&"
import script from "./FormulateAutosuggest.vue?vue&type=script&lang=js&"
export * from "./FormulateAutosuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports